import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import { setUnauthorisedHandler } from './api/client';
import { useAuthStore } from './stores/auth';
import './styles/base.css';

const app = createApp(App);
app.use(createPinia());
app.use(router);

// A refresh failure anywhere in the app ends the session and returns the
// operator to the sign-in screen, rather than leaving a half-dead dashboard.
setUnauthorisedHandler(() => {
  useAuthStore().clearSession();
  void router.push({ name: 'login' });
});

app.mount('#app');
